import {
  HeroSection,
  FeaturesSection,
  ExamplesSection,
  IntegrationsSection,
  CtaSection,
} from "@/components/product/workflow-builder"
import { FooterSection } from "@/components/home/footer"
import { usePageTitle } from "@/hooks/use-page-title"

/**
 * Workflow Builder product page.
 * Showcases the visual workflow automation platform and its capabilities.
 */
export function WorkflowBuilderPage() {
  const pageTitle = usePageTitle(
    "Workflow Builder",
    "Build powerful automations by connecting nodes visually. From simple sequences to complex multi-branch processes - no coding required."
  )

  return (
    <div className="w-full">
      {pageTitle}
      <HeroSection />
      <FeaturesSection />
      <ExamplesSection />
      <IntegrationsSection />
      <CtaSection />
      <FooterSection />
    </div>
  )
}

WorkflowBuilderPage.displayName = "WorkflowBuilderPage"
